import { render } from "./EditConversation.vue?vue&type=template&id=d1495556"
import script from "./EditConversation.vue?vue&type=script&lang=js"
export * from "./EditConversation.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__